export default __webpack_public_path__ + "static/media/id_label.42d96226.png";